<mat-selection-list [multiple]="false" hideSingleSelectionIndicator (selectionChange)="onConditionSetSelected($event)" class="mc-list-text-size-normal mc-list-text-weight-normal mc-list-bg-light mat-accent-vivid">
  <mat-list-option *ngFor="let conditionSet of conditionSets" [matTooltip]="conditionSet.Name" [value]="conditionSet" [selected]="selectedSet === conditionSet">
    <span class="mc-truncate">{{conditionSet.Name}}</span>
  </mat-list-option>
</mat-selection-list>